import { useNavigate } from 'react-router-dom';
import { useCustomers } from '../../customers/hooks/useCustomers';
import type { Customer } from '../../customers/customer.types';

function RepresentativeUserRow({ customer }: { customer: Customer }) {
  const navigate = useNavigate();

  return (
    <div
      role="link"
      tabIndex={0}
      aria-label={`مشاهده جزئیات ${customer.name}`}
      onClick={() => navigate(`/customers/${customer.id}`)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          navigate(`/customers/${customer.id}`);
        }
      }}
      className="representative-profile-user-row"
    >
      <div className="representative-profile-user-row__identity">
        <span className="representative-profile-user-row__avatar" aria-hidden="true">
          {customer.name.trim().charAt(0).toUpperCase()}
        </span>
        <div className="representative-profile-user-row__name">
          <span>{customer.name}</span>
          <span>{customer.contact}</span>
        </div>
      </div>

      <span className="representative-profile-user-row__telegram">
        {customer.telegramId}
      </span>
      <span className="representative-profile-user-row__orders">
        {customer.ordersCount}
      </span>
    </div>
  );
}

export function RepresentativeUsersSection() {
  const { customers, loading } = useCustomers();

  return (
    <section className="representative-profile-section" aria-labelledby="representative-users-title">
      <div className="representative-profile-section__heading">
        <h2 id="representative-users-title">مشتریان</h2>
      </div>

      <div className="representative-profile-users" role="table" aria-label="فهرست مشتریان">
        <div className="representative-profile-user-row representative-profile-user-row--header" role="row">
          <span role="columnheader">مشتری</span>
          <span role="columnheader">شناسه تلگرام</span>
          <span role="columnheader">سفارش‌ها</span>
        </div>

        {loading ? (
          <p className="representative-profile-users__state">در حال دریافت مشتریان...</p>
        ) : customers.length === 0 ? (
          <p className="representative-profile-users__state">مشتری‌ای یافت نشد.</p>
        ) : (
          customers.map((customer) => (
            <RepresentativeUserRow key={customer.id} customer={customer} />
          ))
        )}
      </div>
    </section>
  );
}
